const DEFAULT_BAR_COUNT = 48;

/** Deterministic pseudo-random bar heights in [0.15, 1] for SVG waveform geometry. */
export function buildMediaPlayerWaveformHeights(
	seed: string,
	barCount = DEFAULT_BAR_COUNT,
): number[] {
	let hash = 0;
	for (let i = 0; i < seed.length; i++) {
		hash = (hash * 31 + seed.charCodeAt(i)) | 0;
	}
	const heights: number[] = [];
	for (let i = 0; i < barCount; i++) {
		hash = (hash * 1_103_515_245 + 12_345 + i) | 0;
		const normalized = (hash >>> 0) / 0xffff_ffff;
		heights.push(0.15 + normalized * 0.85);
	}
	return heights;
}

export function resolveWaveformPlayedBarCount(
	progressPercent: number,
	barCount: number,
): number {
	const clamped = Math.max(0, Math.min(100, progressPercent));
	return Math.round((clamped / 100) * barCount);
}
